import { Component } from '@angular/core';

@Component({
  selector: 'app-intuit-copyright',
  templateUrl: './intuit-copyright.component.html',
  standalone: false,
})
export class IntuitCopyrightComponent {
  constructor() {}
}
